import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Spinner } from "@/components/ui/spinner";
import { BUTTONS } from "@/utils/constants/appConstants/commonConstants";
import { APACHE_DIRECTORY_FORM } from "@/utils/constants/appConstants/DirectoryConstants";

const ApacheCredentialForm = () => {
    const [formData, setFormData] = React.useState<any>({});
    const [loading, setLoading] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState({ url: "", admin: "", password: "" });
    const navigate = useNavigate();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prevData: any) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!formData.url) {
            setErrMsg((prev) => ({ ...prev, url: APACHE_DIRECTORY_FORM.errorMsgs.emptyServerUrl }));
        } else if (!formData.password) {
            setErrMsg((prev) => ({ ...prev, password: APACHE_DIRECTORY_FORM.errorMsgs.emptyAdminPassword }));
        } else if (!formData.admin) {
            setErrMsg((prev) => ({ ...prev, admin: APACHE_DIRECTORY_FORM.errorMsgs.emptyAdminDn }));
        } else {
            setLoading(true);
            setErrMsg({ url: "", admin: "", password: "" });
        }
    };

    return (
        <div className="gs-directory-card">
            <form className="gs-directory-card__section" onSubmit={handleSubmit}>
                <div className="gs-directory-field">
                    <label className="gs-directory-field__label" htmlFor="apache-server-url">
                        {APACHE_DIRECTORY_FORM.serverUrl}
                    </label>
                    <Input
                        id="apache-server-url"
                        type="text"
                        name="url"
                        value={formData.url ?? ""}
                        onChange={handleChange}
                        className="gs-directory-field__input"
                        required
                    />
                    {errMsg.url && <p className="gs-directory-field__error">{errMsg.url}</p>}
                </div>
                <div className="gs-directory-field">
                    <label className="gs-directory-field__label" htmlFor="apache-admin-dn">
                        {APACHE_DIRECTORY_FORM.adminDn}
                    </label>
                    <Input
                        id="apache-admin-dn"
                        type="text"
                        name="admin"
                        value={formData.admin ?? ""}
                        onChange={handleChange}
                        className="gs-directory-field__input"
                        required
                    />
                    {errMsg.admin && <p className="gs-directory-field__error">{errMsg.admin}</p>}
                </div>
                <div className="gs-directory-field">
                    <label className="gs-directory-field__label" htmlFor="apache-admin-password">
                        {APACHE_DIRECTORY_FORM.adminPassword}
                    </label>
                    <Input
                        id="apache-admin-password"
                        type="password"
                        name="password"
                        value={formData.password ?? ""}
                        onChange={handleChange}
                        className="gs-directory-field__input"
                        required
                    />
                    {errMsg.password && <p className="gs-directory-field__error">{errMsg.password}</p>}
                </div>
                <div className="gs-directory-form-actions">
                    <Button type="submit" className="gs-directory-action-btn" disabled={loading}>
                        {loading ? <Spinner size="sm" className="mr-2" /> : null}
                        {BUTTONS.SAVE}
                    </Button>
                    <Button type="button" variant="light" className="gs-directory-action-btn" onClick={() => navigate("/settings")}>
                        {BUTTONS.CANCEL}
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default ApacheCredentialForm;
